import { render, staticRenderFns } from "./FilesNavigationSearch.vue?vue&type=template&id=3130435e"
import script from "./FilesNavigationSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesNavigationSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports